export const AGENCY_MARKETER_RECEIVED = 'AGENCY_MARKETER_RECEIVED';
export const agencyMarketerReceived = (data) => ({
    type: AGENCY_MARKETER_RECEIVED,
    payload: { data }
});


// WEBPACK FOOTER //
// ./src/agency/redux/AgencyMarketerReceived.js